import { useState } from "react";
import { ChevronDown, ChevronUp, HelpCircle } from "react-feather";
import { Card, CardBody, CardHeader, Collapse } from "reactstrap";
import { AccordionCardPropsType } from "../../../Type/Faq";
import { Btn, H5 } from "../../../AbstractElements";

const AccordionCard = ({ item }: AccordionCardPropsType) => {
  const [isActivity, setIsActivity] = useState(false);
  const handelChange = () => {
    setIsActivity(!isActivity);
  };
  
  return (
    <Card className="shadow-none">
      <CardHeader className="card-header card-no-border pb-0">
        <H5 className="mb-0">
          <Btn tag="a"  className="btn-link collapsed ps-0 justify-content-between fw-bold" onClick={handelChange}>
            <span className="d-flex align-items-center gap-2"><HelpCircle  />{item.title}</span>
            {isActivity ? (
              <ChevronUp className="position-relative inset-0 m-0" />
            ) : (
              <ChevronDown className="position-relative inset-0 m-0" />
            )}
          </Btn>
        </H5>
      </CardHeader>
      <Collapse isOpen={isActivity}>
        <CardBody>{item.paragraph}</CardBody>
      </Collapse>
    </Card>
  );
};

export default AccordionCard;
